import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'media/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('media/', '')
      .toLowerCase();
  }
}
